import React, { Component } from 'react';

class DietGroups extends Component {
  handleClick(value) {
    let dataArray = this.props.dataArray || {};
    let dietGroups = dataArray.dietGroups || {};
    let dietListByGroup =
      dataArray.dietListByGroup || [];

    let diet = this.props.diet;

    let selectedGroup =
      dietListByGroup.find(function(item) {
        return item.id == value;
      });

    if (
      selectedGroup &&
      selectedGroup.data &&
      selectedGroup.data.length > 0
    ) {
      diet = selectedGroup.data[0].id;
    }

    this.props.onChange({
      diet_group: value,
      diet: +diet,
      dietGroupList:
        selectedGroup || {}
    });
  }

  render() {
    let dietGroups =
      (this.props.dataArray || {}).dietGroups ||
      {};
    
    let selected =
      this.props.diet_group;
   
    return (
      <section
        className="goal-section"
        id="goal"
      >
        <div className="goal-heading">
          <div className="goal-number">
            01
          </div>
          <h2>
            What is your Wellness Goal?
          </h2>
          <span>01</span>
        </div>

        <div className="goal-grid">
          {Object.keys(dietGroups).map(
            function(value) {
              let isSelected =
                selected == value;

              let title =
                dietGroups[value] || '';
               let icon=this.props.dietGroupIcons[value] || this.props.dietGroupIcons[1];
              return (
                <div
                  key={value}
                  className={
                    'goal-card ' +
                    (isSelected
                      ? 'selected'
                      : '')
                  }
                  onClick={function() {
                    this.handleClick(value);
                  }.bind(this)}
                  
                ><div className="prod_infogrid"><div className="goal-icon"
        dangerouslySetInnerHTML={{ __html: icon }} 
      />
                  <h3>
                    {title}
                  </h3>
                </div>
                  <button
                    type="button"
                    onClick={function(e) {
                      e.stopPropagation();
                      this.handleClick(value);
                    }.bind(this)}
                  >
                    View Options
                  </button>
                </div>
              );
            }.bind(this)
          )}
        </div>
      </section>
    );
  }
}

export default DietGroups;
